import React from 'react';
import { SpinnerContainer } from './styles';

const Spinner = ({ small }) => {
  return <SpinnerContainer small={small}>Loading...</SpinnerContainer>;
};

export default Spinner;
